var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"fade"}},[_c('b-img',{staticClass:"touchable-indicator pulse",attrs:{"fluid":"","src":_vm.TouchableImage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }